import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SpondylosisPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Spondylosis</h1>
        <section className="mb-8">
          <p>Spondylosis refers to age-related wear and tear of the spinal discs and joints, often leading to pain, stiffness, and reduced mobility. It can affect the neck (cervical), lower back (lumbar), or other parts of the spine. Natural therapies can help manage symptoms and support spinal health for improved comfort and movement.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Aging and degeneration</li>
            <li>Previous spinal injuries</li>
            <li>Poor posture</li>
            <li>Repetitive stress on the spine</li>
            <li>Genetic predisposition</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Back or neck pain and stiffness</li>
            <li>Reduced range of motion</li>
            <li>Numbness or tingling in limbs</li>
            <li>Muscle weakness</li>
            <li>Headaches (if cervical)</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, soothing oils, and gentle therapies to reduce pain and stiffness, restore mobility, and support long-term spinal health. Each plan is tailored to your needs for safe, effective relief.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces pain and stiffness</li>
            <li>Improves spinal flexibility</li>
            <li>No harsh side effects</li>
            <li>Personalized, gentle care</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Practice regular stretching and yoga</li>
            <li>Maintain good posture</li>
            <li>Use ergonomic furniture</li>
            <li>Stay physically active</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment help with chronic spondylosis?</strong>
            <p>A: Yes, our approach is effective for both cervical and lumbar spondylosis.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for seniors?</strong>
            <p>A: Absolutely, our therapies are gentle and suitable for all ages.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I feel relief?</strong>
            <p>A: Many patients notice improvement within a few sessions.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Support your spine—book your natural spondylosis consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default SpondylosisPage; 